import { gql } from "@apollo/client";

export const SIGNUP_MUTATION = gql`
  mutation RegisterUser($data: UserInputData!) {
    createUser(data: $data) {
      user {
        firstName
        lastName
        email
      }
    }
  }
`;
